
<template>
  <div>
    <draggable
      v-bind="dragOptions"
      tag="div"
      class="widget-item-container mb-2"
      :list="list"
      :value="value"
      @input="inputEmit"
      @start="startEmit"
      @end="endEmit"
      swapThreshold="1"
    >
      <div class="widget-item-group item-group" :key="el.id" v-for="(el, key) in realValue">
        <slot :data="el" :index="key"></slot>
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import Routes from "@/router/views";
import { mapState } from "vuex";
export default {
  name: "nested-test",
  methods: {
    inputEmit(value) {
      this.$emit("input", value);
    },
    startEmit(value) {
      this.$emit("start", value);
    },
    endEmit(value) {
      this.$emit("end", value);
    },
    expanel(data) {
      console.log(data);
      return false;
    }
  },
  components: {
    draggable,
  },
  computed: {
    ...mapState({
      autoSelects: state => state.Widget.Widgets.autoSelects
    }),
    dragOptions() {
      return {
        animation: 0,
        group: "widget",
        disabled: false,
        ghostClass: "ghost",
        put: () => true,
        pull: false
      };
    },
    realValue() {
      return this.value ? this.value : this.list;
    }
  },
  created() {
    /**
     * Auto Selectleri Set Et
     */
    const autoSelects = {
      systemViews: Routes
    };
    this.$store.dispatch("Widget/Widgets/getAutoSelects", autoSelects);
  },
  props: {
    value: {
      required: false,
      type: Array,
      default: null
    },
    list: {
      required: false,
      type: Array,
      default: null
    }
  }
};
</script>

<style>
.item-container {
  max-width: 20rem;
  margin: 0;
}
.item {
  padding: 1rem;
  border: solid black 1px;
  background-color: #fefefe;
}
.item-sub {
  margin: 0 0 0 1rem;
}

.widget-container-empty .widget-item-container {
  min-height: 48px;
}

.ghost .widget-item {
  background: rgba(0, 136, 249, 0.09);
  border: 1px dashed #0088f8;
  color: transparent;
}
.ghost .widget-item > * {
  opacity: 0;
}
.widget-item-sub {
  width: 100%;
}

.widget-drag-icon {
  width: 10px;
  left: -10px;
  cursor: grab;
}

.widget-minus-icon {
  width: 15px;
  height: 10px;
  display: none;
}

.item-group.ghost .widget-item {
  background-color: #cedeff;
}

/* .widget-input-sysname {
  position: relative;
}

.widget-input-sysname span {
  position: absolute;
  top: 0;
  left: 0;
  width: 10px;
  height: 10px;
  background-color: red;
} */
</style>

